import React from 'react';
import { HeaderMovilCS } from 'pages/Header/Content/pages/HeaderMovil'
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito'
import styles from '../ModulosMovimientos/movimientos.module.sass'
import { Error500 } from 'components/Error/Error500'
import { MovementsCards } from '../ModulosMovimientos'

export function MovimientosMobile(props) {

    const {
        respMovements,
        errorCode
    } = props

    return (
        <>
            <HeaderMovilCS />
            <div className="modalCredito full">
                <div className="contentModal">
                    <HeaderMobileCredito title="Movimientos" type="back" /> 
                    {errorCode >= 500
                            ? <Error500 />
                            : respMovements
                                ? <MovementsCards respMovements={respMovements} />
                                : null
                        }
                </div>
            </div>
        </>
    )
}